import React from 'react';
import { MainLayout } from '../components';
import OrganizationProfileForm from '../components/OrganizationProfileForm';
import styles from './CreateOrganizationPage.module.css';

const CreateOrganizationPage: React.FC = () => {
  return (
    <MainLayout>
      <div className={styles.container}>
        <h1 className={styles.title}>Créer une organisation</h1>
        <p className={styles.subtitle}>
          Remplissez ce formulaire pour créer votre profil d'organisation et commencer à publier des événements.
        </p>
        
        <div className={styles.formWrapper}>
          <OrganizationProfileForm isEditing={false} />
        </div>
      </div>
    </MainLayout>
  );
};

export default CreateOrganizationPage;
